import valuePropApp from '@perpay-web/fintech/assets/images/valuePropApp.png';
import valuePropSilverPremiumApp from '@perpay-web/fintech/assets/images/valuePropSilverPremiumApp.png';
import ApplicationValueProp from '@perpay-web/fintech/components/composite/ApplicationValueProp/ApplicationValueProp';

import styles from './CardApplicationValueProp.scss';

const CardApplicationValueProp = ({
    isUserInPremiumGroup = false,
    onValuePropView,
    className = '',
    welcomeOffer = null,
}) => {
    const benefitsListComponent = (
        <>
            <div className={styles.list__item}>
                <div className={styles.list__icon} />
                Credit limit <span className={styles.semi}>increases</span> in
                as few as 3 months
            </div>
            <div className={styles.list__item}>
                <div className={styles.list__icon} />
                <span className={styles.semi}>Build your credit</span> with
                payroll direct deposit
            </div>
            <div className={styles.list__item}>
                <div className={styles.list__icon} />
                Earn <span className={styles.semi}>2% rewards</span> on all
                payments
                <sup className={styles['disclaimer-footnote']}>1</sup>
            </div>
            <div className={styles.list__item}>
                <div className={styles.list__icon} />
                Use anywhere <span className={styles.semi}>Mastercard</span> is
                accepted and enjoy{' '}
                <span className={styles.semi}>exclusive perks</span> from Lyft,
                Instacart and Peacock
            </div>
        </>
    );

    return (
        <ApplicationValueProp
            className={className}
            welcomeOffer={welcomeOffer}
            imageSrc={
                isUserInPremiumGroup ? valuePropSilverPremiumApp : valuePropApp
            }
            onValuePropView={onValuePropView}
            benefitTitle='Get up to a $1,500 starting limit'
            benefitsListComponent={benefitsListComponent}
        />
    );
};

export default CardApplicationValueProp;
